// Displays the CPR4homes sales-rep mascot image.
// Default image: frontend/public/cpr-mascot.png
// Poses (frontend/public/mascot/mascot-<pose>.png): thumbsup, pointing, writing,
// armscrossed, roof, presenting, ok, folder
const POSES = ['thumbsup', 'pointing', 'writing', 'armscrossed', 'roof', 'presenting', 'ok', 'folder'];
export default function RepMascot({ height = 150, pose, style = {}, className = '' }) {
  const src = pose && POSES.includes(pose) ? `/mascot/mascot-${pose}.png` : '/cpr-mascot.png';
  return (
    <img src={src} alt="CPR4homes rep" height={height} className={className}
      style={{ height, width: 'auto', display: 'block', ...style }} />
  );
}
